import { Button, Typography } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userTrainingRegisterAction } from "../../../redux/actions/training_action";
import OpenModal from "../../../common/actions/OpenModal";

function TrainingRegisterButton({ data }) {
  const [loading, setLoading] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("");

  const dispatch = useDispatch();

  const { message } = useSelector((state) => state.training);

  const handleIsDone = () => setIsDone((prev) => !prev);
  const handleOpen = () => setOpen((prev) => !prev);

  const handleType = (type) => {
    setType(type);
    setOpen(true);
  };

  const handleRegister = () => {
    setLoading(true);
    dispatch(
      userTrainingRegisterAction({ id: data.id, year: data.year, type })
    ).finally(() => setLoading(false));
  };

  useEffect(() => {
    if (message) {
      setIsDone((prev) => !prev);

      const timer = setTimeout(() => {
        window.location.reload();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <div className="flex flex-col gap-4 md:flex-row md:items-center mb-2">
        <Button
          color="green"
          onClick={() => handleType("In-Person")}
          fullWidth
          size="lg"
        >
          Click Here for <span className="text-3xl">In-Person</span>{" "}
          Participation
        </Button>

        {/* <Button
          color="light-blue"
          onClick={() => handleType("Virtual")}
          disabled={loading}
          fullWidth
          size="lg"
        >
          Click Here for <span className="text-3xl">Virtual</span> Participation
        </Button> */}
      </div>

      {open && (
        <OpenModal
          open={open}
          handler={handleOpen}
          title="Confirmation"
          children={
            <Typography color="black">
              Please confirm your registeration for{" "}
              <span className="font-bold">
                {data.name}, {type}
              </span>{" "}
              meeting and training session.
            </Typography>
          }
          actionTitle="Register"
          loading={loading}
          handleSubmit={handleRegister}
        />
      )}

      {isDone && (
        <OpenModal
          open={isDone}
          handler={handleIsDone}
          title="Success"
          children={
            <Typography color="black">
              You have successfully registered for{" "}
              <span className="font-bold">{data.name}</span>.
            </Typography>
          }
        />
      )}
    </>
  );
}

export default TrainingRegisterButton;
